import type { SeriesUnit } from 'features/Series/api/series.types'

const ADVERB: Record<SeriesUnit, string> = { day: 'Daily', week: 'Weekly', month: 'Monthly' }

// "Weekly" for a spacing of one, else "Every 3 days".
export const cadenceText = (every: number, unit: SeriesUnit): string =>
  every === 1 ? ADVERB[unit] : `Every ${every} ${unit}s`
